export function lockRecord(serviceKey, component, recordId) {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_LOCK_RECORD', component, recordId, serviceKey});
    };
}

export function unlockRecord(serviceKey, component, recordId) {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_UNLOCK_RECORD', component, recordId, serviceKey});
    };
}

export function setLockedRecords(serviceKey, component, recordIds) {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_SET_LOCKED', component, recordIds, serviceKey});
    };
}

export function lockOverride(records) {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_SET_LOCKED_OVERRIDE', records});
    };
}

export function setUpdatedLocks(lockedRecords) {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_UPDATE', lockedRecords});
    };
}

export function checkLockedRecords() {
    return (dispatch) => {
        dispatch({type: 'RECORD_LOCKING_CHECK_LOCKS'});
    };
}
